<template>
    <div class="divider">
        <span v-if="title">{{ $t('login.or') }}</span>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        title: {
            type: String,
            default: null,
        },
    },
});
</script>
<style scoped>
.divider {
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.5;

    span {
        position: relative;
        z-index: 5;
        background: white;
        padding: 0 1rem;
    }

    &::after {
        display: block;
        position: absolute;
        content: '';
        border-bottom: 1px solid #202020;
        width: 100%;
        opacity: 0.6;
    }
}
</style>
